<template>
  <div ref="box"></div>
</template>

<script>
import { loadTurnstile, createFailOpenTimer } from "@/utils/turnstile";

export default {
  name: "TurnstileWidget",
  props: {
    siteKey: { type: String, required: true },
    action: { type: String, default: "login" },
  },
  data() {
    return { widgetId: null, destroyed: false, failOpen: null };
  },
  mounted() {
    // No token and no error within 15 s: treat as a widget error (fail open; BE decides).
    this.failOpen = createFailOpenTimer(() => this.$emit("error"));
    loadTurnstile()
      .then((turnstile) => {
        if (this.destroyed) return;
        this.widgetId = turnstile.render(this.$refs.box, {
          sitekey: this.siteKey,
          action: this.action,
          language: "th",
          callback: (token) => {
            this.failOpen.stop();
            this.$emit("verify", token);
          },
          "expired-callback": () => {
            this.failOpen.stop();
            this.$emit("expire");
          },
          "timeout-callback": () => {
            this.failOpen.stop();
            this.$emit("expire");
          },
          "error-callback": () => {
            this.failOpen.stop();
            this.$emit("error");
          },
        });
        this.failOpen.start();
      })
      .catch(() => {
        if (!this.destroyed) this.$emit("error");
      });
  },
  beforeDestroy() {
    this.destroyed = true;
    if (this.failOpen) this.failOpen.stop();
    if (this.widgetId !== null && window.turnstile) {
      try {
        window.turnstile.remove(this.widgetId);
      } catch (e) {
        /* widget already gone */
      }
    }
  },
  methods: {
    reset() {
      if (this.widgetId !== null && window.turnstile) {
        window.turnstile.reset(this.widgetId);
        if (this.failOpen) this.failOpen.start();
      }
    },
  },
};
</script>
